export default "{{message?.text }}"